//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "scatter",
  //散点图
  computed: {
    x2: function x2() {
      return this.option.gridX2 || 20;
    }
  },
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      var optionData = this.deepClone(this.dataChart);
      var option = {
        title: this.ishasprop(this.option.titleShow, {
          text: this.option.title,
          subtext: this.option.subtext || '',
          textStyle: {
            color: this.option.titleColor || '#333',
            fontSize: this.option.titleFontSize || 16
          },
          left: this.option.titlePostion || 'auto',
          subtextStyle: {
            color: this.option.subTitleColor || '#aaa',
            fontSize: this.option.subTitleFontSize || 14
          }
        }, {}),
        tooltip: {
          formatter: this.option.formatter || '',
          backgroundColor: this.option.tipBackgroundColor || 'rgba(50,50,50,0.7)',
          textStyle: {
            fontSize: this.option.tipFontSize,
            color: this.option.tipColor || "#fff"
          }
        },
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        xAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: function () {
          var barColor = _this.option.barColor || [];
          var list = (optionData || []).map(function (ele, index) {
            return Object.assign(ele, {
              type: "scatter",
              itemStyle: {
                color: _this.getColor(index)
              },
              label: {
                show: _this.vaildData(_this.option.labelShow, false),
                //开启显示
                position: "top",
                textStyle: {
                  fontSize: _this.option.fontSize || 14,
                  color: _this.option.labelShowColor || "#333",
                  fontWeight: _this.option.labelShowFontWeight || 500
                }
              }
            });
          });
          return list;
        }()
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});